define("shared/validations/generated-caption", ["exports", "ember-changeset-validations/validators"], function (_exports, _validators) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-changeset-validations/validators"eaimeta@70e063a35619d71f
  var _default = _exports.default = {
    topic: [(0, _validators.validatePresence)({
      message: 'caption_writer.validations.presence',
      presence: true
    }), (0, _validators.validateLength)({
      message: 'caption_writer.validations.length',
      min: 3 /* max: 160 */
    })],
    tone: [(0, _validators.validateLength)({
      message: 'caption_writer.validations.tone_length',
      min: 3,
      max: 20
    })]
  };
});